import React from "react";
import styles from "./Example.module.css"; // Asegúrate de que esta ruta sea correcta

export const ExampleList = () => {
    const chatTips = [
        //<>
        //     <span className={styles.highlight}>iArte</span> da <span className={styles.highlight}>respuesta a tus dudas</span> de <span className={styles.highlight}>productos, promos</span> y <span className={styles.highlight}>operativas</span>. Los <span className={styles.highlight}>comunicados</span> los seguirás teniendo <span className={styles.highlight}>disponibles en ELYPSE</span>.
        //</>,
        //<>
        //    Recuerda <span className={styles.highlight}>preguntar</span> con el <span className={styles.highlight}>máximo detalle</span> para obtener una <span className={styles.highlight}>mejor respuesta</span>.
        //</>,
        //<>
        //    Si tienes una <span className={styles.highlight}>pregunta</span> acerca de un <span className={styles.highlight}>modo específico</span>, haz tu pregunta con <span className={styles.highlight}>#modo</span> y tu <span className={styles.highlight}>pregunta</span>.
        //</>,
        //<>
        //    Utiliza palabras como <span className={styles.highlight}>"Vigente"</span> o <span className={styles.highlight}>"Actual"</span> para documentos recientes, y <span className={styles.highlight}>"No Vigente"</span> o <span className={styles.highlight}>"Anterior"</span> para los pasados.
        //</>
        <>
           <span className={styles.highlight}>Pregunta con el máximo detalle</span> para tener la mejor respuesta. Si es un <span className={styles.highlight}>modo específico pincha #</span> y selecciona el #modo.
        </>,
        <>
            Los <span className={styles.highlight}>comunicados</span> están disponibles en pestaña NOVEDADES.
        </>
    ];

    return (
        <div>
            <h2 className={styles.tipsTitle}>Consejos de uso</h2>
            <ul className={styles.examplesNavUl}>
                {chatTips.map((tip, index) => (
                    <li className={styles.examplesNavList} key={index}>
                        <div className={styles.example}>
                            <div className={styles.exampleText}>{tip}</div>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};
